module.exports = __webpack_public_path__ + "img/icon4.9fed15a0.svg";